export default class ZoomPanHandler {
  constructor(minZoom = 0.5, maxZoom = 3, zoomStep = 0.1) {
    this.minZoom = minZoom;
    this.maxZoom = maxZoom;
    this.zoomStep = zoomStep;
    this.zoomLevel = 1;
    this.isPanning = false;
    this.startX = 0;
    this.startY = 0;
    this.offsetX = 0;
    this.offsetY = 0;
    this.initialDistance = 0;
    this.initialZoom = 1;
  }

  handleScroll(event) {
    event.preventDefault();
    if (event.deltaY < 0 && this.zoomLevel < this.maxZoom) {
      // Zoom in
      this.zoomLevel += this.zoomStep;
    } else if (event.deltaY > 0 && this.zoomLevel > this.minZoom) {
      // Zoom out
      this.zoomLevel -= this.zoomStep;
    }
  }

  startPanning(event) {
    this.isPanning = true;
    this.startX = event.clientX - this.offsetX;
    this.startY = event.clientY - this.offsetY;
  }

  pan(event) {
    if (this.isPanning) {
      this.offsetX = event.clientX - this.startX;
      this.offsetY = event.clientY - this.startY;
    }
  }

  stopPanning() {
    this.isPanning = false;
  }

  handleTouchStart(event) {
    if (event.touches.length === 2) {
      this.initialDistance = this.getDistance(event.touches);
      this.initialZoom = this.zoomLevel;
    } else if (event.touches.length === 1) {
      this.startPanning(event.touches[0]);
    }
  }

  handleTouchMove(event) {
    event.preventDefault();
    if (event.touches.length === 2) {
      const currentDistance = this.getDistance(event.touches);
      const scaleChange = currentDistance / this.initialDistance;
      this.zoomLevel = Math.min(
        Math.max(this.initialZoom * scaleChange, this.minZoom),
        this.maxZoom,
      );
    } else if (event.touches.length === 1 && this.isPanning) {
      this.pan(event.touches[0]);
    }
  }

  handleTouchEnd() {
    this.isPanning = false;
    this.initialDistance = 0;
    this.initialZoom = 1;
  }

  getDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }
}
